import { ThemeService } from './theme.service';

export default angular
  .module('sfMobile.services.theme', [
    'sfMobile.constants.organisation-preferences',
    'sfMobile.constants.colors',
  ])
  .service('themeService', ThemeService).name;
